import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowLeft,
  faArrowRight,
  faLessThan,
  faGreaterThan,
  faEquals,
  faNotEqual,
} from '@fortawesome/free-solid-svg-icons';
import RuleUtils from '../../Lib/RuleUtils';

const ConditionColumn = ({ type, threshold }) => {
  const ruleUtils = new RuleUtils();
  const CONDITIONS_ICON_MAP = new Map([
    ['lessThan', faLessThan],
    ['greaterThan', faGreaterThan],
    ['equalTo', faEquals],
    ['notEqualTo', faNotEqual],
  ]);

  switch (type) {
    case 'outsideOf':
      return (
        <span
          className="three-quarter-text text-muted overflow-hidden py-1"
          style={{ maxHeight: '2.25rem' }}
        >
          <span className="text-dark font-weight-bold">{`${threshold[0]} `}</span>
          <FontAwesomeIcon className="text-brand-primary" icon={faArrowLeft} />{' '}
          <FontAwesomeIcon className="text-brand-primary" icon={faArrowRight} />
          <span className="text-dark font-weight-bold">{` ${threshold[1]}`}</span>
        </span>
      );
    case 'between':
      return (
        <span
          className="three-quarter-text text-muted overflow-hidden py-1"
          style={{ maxHeight: '2.25rem' }}
        >
          <span className="text-dark font-weight-bold">{`${threshold[0]} `}</span>
          <FontAwesomeIcon className="text-brand-primary" icon={faArrowRight} />{' '}
          <FontAwesomeIcon className="text-brand-primary" icon={faArrowLeft} />
          <span className="text-dark font-weight-bold">{` ${threshold[1]}`}</span>
        </span>
      );
    case 'contains':
    case 'startsWith':
    case 'endsWith':
      return (
        <span
          className="three-quarter-text text-muted overflow-hidden py-1"
          style={{ maxHeight: '2.25rem' }}
        >
          <span className="text-brand-primary font-weight-medium">
            {ruleUtils.ruleTypeDisplayMap.get(type)}
          </span>
          <span className="text-dark font-weight-bold">{` ${threshold}`}</span>
        </span>
      );
    case '':
      return null;
    default:
      return (
        <span
          className="three-quarter-text text-muted overflow-hidden py-1"
          style={{ maxHeight: '2.25rem' }}
        >
          <FontAwesomeIcon
            className="text-brand-primary"
            icon={CONDITIONS_ICON_MAP.get(type)}
          />
          <span className="text-dark font-weight-bold">{` ${threshold}`}</span>
        </span>
      );
  }
};
ConditionColumn.propTypes = {
  type: PropTypes.string,
  threshold: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.number),
    PropTypes.number,
    PropTypes.string,
  ]),
};
ConditionColumn.defaultProps = {
  type: '',
  threshold: [],
};

export default ConditionColumn;
// imported by ConditionsDropdown.js and MobileDetailsModal.js
